import { GameEventSynthesizerRegistry } from './GameEventSynthesizer';
import { HeartsEventSynthesizer } from '../../Hearts/events/HeartsEventSynthesizer';
import { SpadesEventSynthesizer } from '../../Spades/events/SpadesEventSynthesizer';
import { BidWhistEventSynthesizer } from '../../BidWhist/events/BidWhistEventSynthesizer';

let defaultsRegistered = false;

/**
 * Registers default built-in event synthesizers and their canonical aliases.
 * Idempotent: safe to invoke multiple times.
 */
export function registerDefaultSynthesizers(): void {
  if (defaultsRegistered) {
    return;
  }

  GameEventSynthesizerRegistry.register(
    'HEARTS',
    () => new HeartsEventSynthesizer(),
    ['100_PTS', '50_PTS', 'HEART']
  );

  GameEventSynthesizerRegistry.register(
    'SPADES',
    () => new SpadesEventSynthesizer(),
    ['500_PTS', '250_PTS', '300_PTS']
  );

  GameEventSynthesizerRegistry.register(
    'BID_WHIST',
    () => new BidWhistEventSynthesizer(),
    ['SEVEN_IN_OUT', 'UP_AND_DOWN', 'NO_TRUMP', 'BEST_OF_3']
  );

  defaultsRegistered = true;
}

// Auto-register defaults on module evaluation
registerDefaultSynthesizers();
